import * as R from 'ramda'
import round from 'lodash/round'
import toNumber from 'lodash/fp/toNumber'

/**
 * @param {string|*} currency
 * @return {string}
 * @private
 */
export const _parse_currency = R.ifElse(R.is(String), R.trim, R.always(''))

/**
 * @param {string|*} currency
 * @param {number} precision
 * @return {function(number|*):string}
 *
 * to_currency('€')(2) => '2,00 €'
 * to_currency('€', 4)(2) => '2,0000 €'
 * to_currency('€')(null) => '0,00 €'
 * to_currency('€', 3)('a') => '0,000 €'
 */
function _to_currency(currency, precision = 2) {
    return R.compose(

        // Spaces entfernen
        R.trim,

        // String erstellen
        string => `${string} ${_parse_currency(currency)}`,

        // Punkt durch Komma ersetzen
        R.replace('.', ','),

        // Auf `precision`-Stellen runden
        number => round(number, precision).toFixed(precision),

        // ggf. Standardwert setzen
        R.defaultTo(0),

        // Zu Nummer parsen
        toNumber,

    )
}

export const to_currency = R.curry(_to_currency)
